module.exports = __webpack_public_path__ + "img/threads.f388c62e.svg";